import { render, staticRenderFns } from "./headbar.vue?vue&type=template&id=24ea276c&"
import script from "./headbar.vue?vue&type=script&lang=js&"
export * from "./headbar.vue?vue&type=script&lang=js&"
import style0 from "./headbar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports